import { render, staticRenderFns } from "./StatisticDisasterYear.vue?vue&type=template&id=a53c1532&scoped=true"
import script from "./StatisticDisasterYear.vue?vue&type=script&lang=js"
export * from "./StatisticDisasterYear.vue?vue&type=script&lang=js"
import style0 from "./StatisticDisasterYear.vue?vue&type=style&index=0&id=a53c1532&prod&scoped=true&lang=scss"
import style1 from "./StatisticDisasterYear.vue?vue&type=style&index=1&id=a53c1532&prod&scoped=true&lang=css"
import style2 from "./StatisticDisasterYear.vue?vue&type=style&index=2&id=a53c1532&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53c1532",
  null
  
)

export default component.exports